import React from 'react';
import PropTypes from 'prop-types';

export const TariffPlans = ({ width, height, ...props }) => (
  <svg
    data-icon='tariff-plans'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M6 22a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 3 19v-3h3V2l1.5 1.5L9 2l1.5 1.5L12 2l1.5 1.5L15 2l1.5 1.5L18 2l1.5 1.5L21 2v17c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 18 22H6Zm12-2c.283 0 .52-.096.712-.288A.968.968 0 0 0 19 19V5H8v11h9v3c0 .283.096.52.288.712.191.192.429.288.712.288ZM9 9V7h6v2H9Zm0 3v-2h6v2H9Zm8-3a.968.968 0 0 1-.712-.287A.967.967 0 0 1 16 8c0-.283.096-.52.288-.713A.968.968 0 0 1 17 7c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 17 9Zm0 3a.968.968 0 0 1-.712-.287A.968.968 0 0 1 16 11c0-.283.096-.52.288-.713A.968.968 0 0 1 17 10c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 17 12ZM6 20h9v-2H5v1c0 .283.096.52.287.712.192.192.43.288.713.288Z'
    />
  </svg>
);

TariffPlans.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

TariffPlans.defaultProps = {
  width: 24,
  height: 24,
};
